export { default } from './EditProduct';
